import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-trash',
  templateUrl: './svg-trash.component.html',
  styleUrls: ['./svg-trash.component.css']
})
export class SvgTrashComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
